import { app, Component } from 'apprun';
import { __ } from './Txlat';
export default class AgencyNav extends Component {
  view = (state) => {
    if (typeof (state.propertyCount) !== 'undefined' && typeof (state.agentCount) !== 'undefined') {
      return (
        <div>
          <ul class="nav nav-pills nav-justified">
            <li class="nav-item">
              <a class="nav-link active" href="#tab-properties" data-toggle="pill" role="tab">
                {`${__('Listings')} (${state.propertyCount})`}
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link " href="#tab-agents" data-toggle="pill" role="tab">
                {`${__('Agents')} (${state.agentCount})`}
              </a>
            </li>
          </ul>
        </div>
      );
    }
  };

  update = {
    '/setComponentState': async (state, { properties, agencyAgents }) => {
      state.propertyCount = properties.length;
      state.agentCount = agencyAgents.length;
      return state;
    },
  };
}
